@if (isActive()) {
    <span class="active">{{text()}}</span>
} @else {
    <span class="link" [routerLink]="url()">{{text()}}</span>
}
